export const PARTNER_TAB_INFO_BOX_MESSAGE = `If your partner does not already have a Kindbody portal account,
  they will be sent a link to register. This information will be used to complete your partner's verification
  of benefits.`;

export const INSURANCE_TAB_INFO_BOX_MESSAGE = `Your insurance information is required in order
  for us to start checking your coverage and verifying any benefits, if applicable. If you don’t 
  have insurance and will be paying for your treatment out of pocket, you can use the “I don’t 
  have insurance” toggle above to let our team know and proceed.`;
